<section
  class="min-h-screen flex flex-col items-center justify-center text-center px-6">
  <h1 class="text-6xl font-bold text-red-600 mb-4">404</h1>
  <p i18n="@@not-found.message" class="text-xl text-gray-700 mb-6">
    Sorry, the page you're looking for doesn't exist.
  </p>
</section>
